import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Card, Link, Typography } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../store/directusService';
import { loadParticipant } from '../../store/participantService';
import { POLARIS_BLUE, POLARIS_WHITE, SCREEN_SETTINGS } from '../../themes/theme';
import ParticipantWarning from '../participant/participantWarning/ParticipantWarning';

const RecordedIdentifier = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [contractName, setContractName] = useState('');
    const [serviceName, setServiceName] = useState('');

    // STORE STATE
    const currentParticipantId = useSelector(
        (state) => state.entities.participantService.currentParticipantId
    );
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const loadingContractDetailsForContractId = useSelector(
        (state) => state.entities.directusService.loadingContractDetailsForContractId
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );
    const loadingServiceDetailsForContractId = useSelector(
        (state) => state.entities.directusService.loadingServiceDetailsForContractId
    );

    // FNs
    const participantName = [currentParticipant.firstName, currentParticipant.lastName]
        .filter((el) => el)
        .join(' ')
        .trim();
    const renderTitles = `${participantName} : ${currentParticipant.ptCode} : ${contractName} : ${serviceName}`;

    // USE EFFECTS
    useEffect(() => {
        if (Object.keys(currentParticipant).length === 0 && currentParticipantId) {
            dispatch(loadParticipant(currentParticipantId));
        }
    }, [currentParticipantId]);

    useEffect(() => {
        if (!('contractId' in currentParticipant)) {
            setContractName('');
            setServiceName('');
        }
    }, [currentParticipant]);

    useEffect(() => {
        if (
            currentParticipant &&
            'contractId' in currentParticipant &&
            'serviceId' in currentParticipant &&
            contractDetailsById &&
            servicesByContractId
        ) {
            const { contractId, serviceId } = currentParticipant;
            if (contractId in contractDetailsById) {
                if ('name' in contractDetailsById[contractId])
                    setContractName(contractDetailsById[contractId].name);
            } else
                !loadingContractDetailsForContractId &&
                    dispatch(loadContractDetailsForContractId(contractId));
            if (contractId in servicesByContractId) {
                setServiceName(
                    servicesByContractId[contractId].find((el) => el.id === serviceId)?.name || ''
                );
            } else
                !loadingServiceDetailsForContractId &&
                    dispatch(loadServiceDetailsForContractId(contractId));
        }
    }, [contractDetailsById, servicesByContractId, currentParticipant.serviceId]);

    // RENDER
    return (
        <Card
            sx={{
                backgroundColor: POLARIS_WHITE,
                paddingBottom: SCREEN_SETTINGS.padding.small,
                display: 'flex',
                alignItems: 'center',
                margin: '0 20px 3px',
                padding: '0'
            }}
            elevation={0}>
            <ParticipantWarning participantId={currentParticipant.id} />
            <Link onClick={() => navigate('/edit_participant')} style={{ cursor: 'pointer' }}>
                <Typography
                    variant="h5"
                    component="div"
                    sx={{ flexGrow: 1, color: POLARIS_BLUE, margin: '8px' }}>
                    {Object.keys(currentParticipant)?.length < 1 ? (
                        <div>No Participant selected</div>
                    ) : (
                        <div>{renderTitles}</div>
                    )}
                </Typography>
            </Link>
        </Card>
    );
};
export default RecordedIdentifier;
